import { render, staticRenderFns } from "./accountSummary.vue?vue&type=template&id=5cf155d0&scoped=true&"
import script from "./accountSummary.vue?vue&type=script&lang=js&"
export * from "./accountSummary.vue?vue&type=script&lang=js&"
import style0 from "./accountSummary.vue?vue&type=style&index=0&id=5cf155d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf155d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cf155d0')) {
      api.createRecord('5cf155d0', component.options)
    } else {
      api.reload('5cf155d0', component.options)
    }
    module.hot.accept("./accountSummary.vue?vue&type=template&id=5cf155d0&scoped=true&", function () {
      api.rerender('5cf155d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataPirate/channelCom/accountSummary.vue"
export default component.exports